import type { Row } from '~/composables/useDb'

/**
 * `computeSoldeRow` de la maquette : scolarité, réduction, montant déjà payé, taux et solde d'une inscription.
 * `dateDebut`/`dateFin` (optionnels, AAAA-MM-JJ) restreignent les versements comptés dans « déjà payé » à cette période.
 */
export function computeSoldeRow(inscription: Row, dateDebut?: string | null, dateFin?: string | null) {
  const db = useDb().value
  const etu = findById('personnes', inscription.etudiantId)
  const echeancier = (db.echeanciers ?? []).find(e => e.inscriptionId === inscription.id)
  let scolarite: number
  let reduction: number
  if (echeancier) {
    scolarite = Number(echeancier.montantNet || 0)
    reduction = Number(echeancier.montantRemise || 0)
  }
  else {
    const classe = findById('classes', inscription.classeId)
    const tarif = classe
      ? (db.tarifications ?? []).find(t => isTarifKind(t, 'SCOLARITE') && t.niveauId === classe.niveauId && t.anneeId === inscription.anneeId)
      : null
    scolarite = tarif ? Number(tarif.montant) : 0
    reduction = 0
  }
  const dejaPaye = (db.versements ?? [])
    .filter(v => v.inscriptionId === inscription.id && v.statut === 'ENREGISTRE'
      && (!dateDebut || String(v.datePaiement) >= dateDebut)
      && (!dateFin || String(v.datePaiement) <= dateFin))
    .reduce((s, v) => s + Number(v.montant), 0)
  const solde = scolarite - dejaPaye
  const taux = scolarite > 0 ? (dejaPaye / scolarite * 100) : 0
  return { etu, reduction, scolarite, dejaPaye, taux, solde }
}
